export default __webpack_public_path__ + "static/media/takboxRosa.8a592547.jpg";